const axios = require('axios');

async function allBoots(condition) {
  try {
    const resData = await axios.get('/api/v1/admin/boot/all', { params: condition });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function getBootById(id) {
  try {
    const resData = await axios.get('/api/v1/admin/boot', { params: { id } });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function updateBoot(params) {
  try {
    const resData = await axios.put('/api/v1/admin/boot', params);
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function uploadBootImage(id, imageFile) {
  try {
    const data = new FormData();
    data.append('_id', id);
    data.append('image', imageFile);
    const resData = await axios.put('/api/v1/admin/boot/image', data);
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

module.exports = { allBoots, getBootById, updateBoot, uploadBootImage };
